import React, { useEffect, useState } from "react";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import BranchDeptChatsList from "./widget/BranchDeptChatsList";
import BranchLogoName from "../../../widget/screens/home/BranchLogoName";
import StorageKeys from "../../../const/StorageKeys";
import UtilityHelper from "../../../service/utilities/UtilityHelper";
import {
  HomeContextImport,
  HomeContextProvider,
} from "../../../provider/home/HomeContextProvider";
import Div from "../../../widget/common/ui/Div";
import { SpacingHeight } from "../../../widget/common/ui/Spacing";
import Loader from "../../../widget/common/ui/Loader";
import Center from "../../../widget/common/ui/Center";
import {
  BranchDeptChatsContextImport,
  BranchDeptChatsContextProvider,
} from "../../../provider/branch/branch_dept_chats/BranchDeptChatsContextProvider";
import { SearchChatsList } from "../../../model/branch/BranchChatsModel";
import SearchInput from "../../../widget/common/form/SearchInput";
import CacheStorage from "../../../service/storage/CacheStorage";

const BranchDeptChatsContent = (props: {
  type?: number | undefined;
  isModal?: boolean | false;
}) => {
  const type: number = props.type ?? ResponsiveDeviceType();
  const isModal: boolean = props.isModal ?? false;
  return isModal ? (
    <HomeContextProvider>
      <BranchDeptChatsContextProvider>
        <BranchDeptChatsMainContent type={type} isModal={isModal} />
      </BranchDeptChatsContextProvider>
    </HomeContextProvider>
  ) : (
    <BranchDeptChatsMainContent type={type} isModal={isModal} />
  );
};
export default BranchDeptChatsContent;

const BranchDeptChatsMainContent = (props: {
  type?: number | undefined;
  isModal?: boolean | false;
}) => {
  const type: number = props.type ?? ResponsiveDeviceType();
  const isModal: boolean = props.isModal ?? false;

  const { getBranchDetail, branchDetail } = HomeContextImport();
  const {
    branchDeptListInit,
    deptChatsList,
    onClickDeptChat,
    handleOnChange,
    clearSearch,
    searchValue,
    showSearch,
  } = BranchDeptChatsContextImport();

  const [branchName, setBranchName] = useState<string>("");
  const [branchLogo, setBranchLogo] = useState<string>("");
  const [chatList, setChatList] = useState<Array<SearchChatsList> | null>(null);

  const initData = () => {
    const branchNameSession: string = CacheStorage.getValue(
      StorageKeys.branch_name
    );
    const branchLogoSession: string = CacheStorage.getValue(
      StorageKeys.branch_logo
    );

    if (
      UtilityHelper.isEmpty(branchNameSession) ||
      UtilityHelper.isEmpty(branchLogoSession)
    ) {
      getBranchDetail();
    } else {
      setBranchName(branchNameSession);
      setBranchLogo(branchLogoSession);
    }
  };

  useEffect(() => {
    initData();
    branchDeptListInit();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setChatList(deptChatsList);
  }, [deptChatsList]);

  useEffect(() => {
    if (branchDetail != null) {
      setBranchName(branchDetail?.title!);
      setBranchLogo(branchDetail?.branch_logo_url!);
    }
  }, [branchDetail]);

  return (
    <Div className={`${!isModal && "pt-4 pb-5 h-100"}`}>
      {UtilityHelper.isNotEmpty(branchName) && !isModal && showSearch && (
        <>
          <SearchInput
            name="search-branch-dept"
            placeHolder="search"
            handleOnChange={handleOnChange}
            onClickSuffix={clearSearch}
            value={searchValue}
            autoFocus={true}
            listLogic={true}
          />
        </>
      )}

      <>
        {UtilityHelper.isEmpty(branchName) ? (
          <Center className="h-100">{Loader.normal()}</Center>
        ) : (
          !isModal && (
            <>
              <BranchLogoName name={branchName} logo={branchLogo} type={type} />
              <SpacingHeight value={40} />
            </>
          )
        )}
      </>

      {UtilityHelper.isNotEmpty(branchName) && (
        <BranchDeptChatsList
          chatList={chatList}
          type={type}
          onClickDeptChat={onClickDeptChat}
        />
      )}
    </Div>
  );
};
